import { GridColDef } from "@mui/x-data-grid";
import { createdAtmodifiedAtActions } from "../../../../../helpers/appHelpers";

export const Columns: GridColDef[] = [
	{
		field: "name",
		headerName: "Name",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	{
		field: "description",
		headerName: "Description",
		minWidth: 380,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	{
		field: "code",
		headerName: "Code",
		minWidth: 180,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	{
		field: "active",
		headerName: "Active",
		minWidth: 140,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value ? "Yes" : "No",
	},
	
	...createdAtmodifiedAtActions
];

export const formatDepartmentRank = (rank: number) => {
	switch(rank) {
		case 0: 
			return "Head";
		case 1: 
			return "First Deputy";
		case 2: 
			return "Second Deputy";
		case 3: 
			return "Third Deputy";
		case 4: 
			return "Fourth Deputy";
		case 5: 
			return "Fifth Deputy";
	}
}
